import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import KPIs from "@/pages/KPIs";
import Variables from "@/pages/Variables";
import Captura from "@/pages/Captura";
import Historicos from "@/pages/Historicos";
import Auditoria from "@/pages/Auditoria";
import Ajustes from "@/pages/Ajustes";
import Usuarios from "@/pages/Usuarios";

function Protected({ children, roles }) {
  return <ProtectedRoute roles={roles}>{children}</ProtectedRoute>;
}

function App() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-foreground border-t-transparent" />
      </div>
    );
  }
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/kpis" element={<KPIs />} />
              <Route path="/variables" element={<Variables />} />
              <Route
                path="/captura"
                element={
                  <Protected roles={["admin", "capturista"]}>
                    <Captura />
                  </Protected>
                }
              />
              <Route path="/historicos" element={<Historicos />} />
              <Route
                path="/ajustes"
                element={
                  <Protected roles={["admin"]}>
                    <Ajustes />
                  </Protected>
                }
              />
              <Route
                path="/odoo"
                element={
                  <Protected roles={["admin"]}>
                    <Ajustes />
                  </Protected>
                }
              />
              <Route
                path="/empresas"
                element={
                  <Protected roles={["admin"]}>
                    <Ajustes />
                  </Protected>
                }
              />
              <Route
                path="/usuarios"
                element={
                  <Protected roles={["admin"]}>
                    <Usuarios />
                  </Protected>
                }
              />
              <Route
                path="/auditoria"
                element={
                  <Protected roles={["admin"]}>
                    <Auditoria />
                  </Protected>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
